"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prop-types */
var react_1 = __importStar(require("react"));
var formik_1 = require("formik");
var Box_1 = require("../Box");
var utils_1 = require("../utils");
var Context_1 = require("./Context");
var Form = react_1.default.forwardRef(function (props, ref) {
    var formId = props.formId, onSubmit = props.onSubmit, onSubmitRaw = props.onSubmitRaw, children = props.children, rest = __rest(props, ["formId", "onSubmit", "onSubmitRaw", "children"]);
    var formRef = (0, react_1.useRef)();
    (0, react_1.useImperativeHandle)(ref, function () { return formRef.current; });
    if (!formId) {
        throw new Error('formId is required');
    }
    var handleSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedValues;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onSubmit) return [3 /*break*/, 4];
                    trimmedValues = (0, utils_1.trimObjectValues)(values);
                    // update values to trimmed when form submits
                    formikHelpers.setValues(trimmedValues);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onSubmit(trimmedValues, formRef.current)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    // set submitting even onSubmit fails
                    formikHelpers.setSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(formik_1.Formik, __assign({}, rest, { onSubmit: handleSubmit }),
        react_1.default.createElement(Context_1.FormContextProvider, { formId: formId },
            react_1.default.createElement(FormContextConsumer, { formId: formId, innerRef: formRef, onSubmitRaw: onSubmitRaw }, children))));
});
Form.displayName = 'Form';
exports.default = Form;
function FormContextConsumer(props) {
    var formId = props.formId, onSubmitRaw = props.onSubmitRaw, innerRef = props.innerRef;
    var form = (0, Context_1.useFormContext)();
    (0, react_1.useImperativeHandle)(innerRef, function () { return form; });
    return (react_1.default.createElement(FormContainer, { id: formId, onSubmit: function (event) {
            var formEvent = event;
            form.handleSubmit(formEvent);
            void (onSubmitRaw === null || onSubmitRaw === void 0 ? void 0 : onSubmitRaw(formEvent, form));
        }, onReset: form.handleReset }, typeof props.children === 'function'
        ? props.children(form)
        : props.children));
}
var FormContainer = (0, Box_1.createBasicComponent)({
    display: 'flex',
    flexDirection: 'column'
});
FormContainer.defaultProps = { as: 'form' };
